import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/text-art/',
  headTitle: 'Free Text Art Generator',
  headDescription:
    'Transform your plain text into artistic text with a wide range of options to choose from. Effortlessly copy & paste them for free, and use them as needed.',
  heading: 'Free Text Art Generator',
  description:
    'Convert your text to old-school & retro-looking text art—a fun and artsy way of sharing text with your audience. ',
  selectedCategory: FontCategory.TextArt,
  inputPlaceholder: 'Transform text into art here…',
};

export default props;
